import { DesignToken } from "@livechat/design-system-react-components";

import { getChartFormatter } from "helpers/chart";
import { withVar } from "themes/helpers";

export const chartCommonOptions = {
  credits: false,
  title: false,
  legend: false,
  chart: {
    animation: false,
    height: 250,
  },
  xAxis: {
    lineColor: withVar(DesignToken.BorderBasicSecondary),
    lineWidth: 1,
    tickColor: withVar(DesignToken.BorderBasicSecondary),
    tickLength: 6,
    tickmarkPlacement: "on",
    tickInterval: 1,
    labels: {
      y: 20,
      style: {
        color: withVar(DesignToken.ContentBasicDisabled),
      },
    },
  },
  yAxis: {
    min: 0,
    gridLineColor: withVar(DesignToken.BorderBasicSecondary),
    lineWidth: 0,
    tickWidth: 0,
    title: false,
    allowDecimals: false,
    labels: {
      style: {
        color: withVar(DesignToken.ContentBasicDisabled),
      },
    },
  },
  tooltip: {
    animation: false,
    borderWidth: 0,
    shadow: false,
    backgroundColor: "none",
    useHTML: true,
    borderRadius: 0,
    hideDelay: 0,
    shared: false,
    formatter: getChartFormatter(),
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    positioner(tooltipWidth: any, tooltipHeight: any, point: any) {
      /**
       * Position tooltip on the center of over point
       */
      let x = Math.floor(
        // @ts-expect-error TS(2339): Property 'chart' does not exist on type '{ animati... Remove this comment to see the full error message
        point.plotX + this.chart.plotLeft - this.options.padding - (tooltipWidth - this.options.padding * 2) / 2
      );
      let y = point.plotY - tooltipHeight;

      if (this.shared) {
        y =
          // FIXME: Fix this the next time the file is edited.
          // @ts-expect-error TS2339
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          this.chart.hoverPoints.reduce((acc: any, p: any) => (!acc || acc > p.plotY ? p.plotY : acc), 0) -
          tooltipHeight;
      }

      // @ts-expect-error TS(2339): Property 'chart' does not exist on type '{ animati... Remove this comment to see the full error message
      if (this.shared && this.chart.options.chart.type === "column") {
        // @ts-expect-error TS(2339): Property 'chart' does not exist on type '{ animati... Remove this comment to see the full error message
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const minX = this.chart.hoverPoints.reduce((acc: any, p: any) => (!acc || acc < p.plotX ? p.plotX : acc), 0);
        // @ts-expect-error TS(2339): Property 'chart' does not exist on type '{ animati... Remove this comment to see the full error message
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const maxX = this.chart.hoverPoints.reduce((acc: any, p: any) => (!acc || acc > p.plotX ? p.plotX : acc), 0);

        x =
          (maxX + minX) / 2 +
          // @ts-expect-error TS(2339): Property 'chart' does not exist on type '{ animati... Remove this comment to see the full error message
          this.chart.plotLeft -
          // @ts-expect-error TS(2339): Property 'options' does not exist on type '{ anima... Remove this comment to see the full error message
          this.options.padding -
          // @ts-expect-error TS(2339): Property 'options' does not exist on type '{ anima... Remove this comment to see the full error message
          (tooltipWidth - this.options.padding * 2) / 2;
      }

      /**
       * Prevent position tooltip over the chart
       */
      const isOverLeftSide = x < 0;
      // @ts-expect-error TS(2339): Property 'chart' does not exist on type '{ animati... Remove this comment to see the full error message
      const isOverRightSide = x + tooltipWidth > this.chart.chartWidth;
      // @ts-expect-error TS(2339): Property 'label' does not exist on type '{ animati... Remove this comment to see the full error message
      const tooltipContainer = this.label.div.querySelector(".lc-chart-tooltip");
      const chevronSize = 24;

      tooltipContainer.setAttribute("style", "--chevron-left: 50%");

      if ((isOverLeftSide || isOverRightSide) && !(isOverLeftSide && isOverRightSide)) {
        if (isOverLeftSide) {
          x = 0;
          if (tooltipContainer) {
            tooltipContainer.setAttribute("style", `--chevron-left: ${point.plotX + chevronSize}px`);
          }
        } else if (isOverRightSide) {
          // @ts-expect-error TS(2339): Property 'chart' does not exist on type '{ animati... Remove this comment to see the full error message
          x = this.chart.chartWidth - tooltipWidth;
          if (tooltipContainer) {
            tooltipContainer.setAttribute("style", `--chevron-left: ${point.plotX - x + chevronSize}px`);
          }
        }
      }

      return { x, y };
    },
  },
  plotOptions: {
    column: {
      minPointLength: 2,
      borderWidth: 0,
      stickyTracking: false,
    },
    area: {
      lineWidth: 2,
      fillOpacity: 0.1,
      marker: {
        lineColor: "white",
        symbol: "circle",
        lineWidth: 1,
        radius: 3,
      },
      states: {
        hover: {
          lineWidth: 2,
        },
      },
      trackByArea: true,
    },
    series: {
      animation: false,
      shadow: false,
    },
  },
  series: [],
};
